import axios from 'axios';
import { GlobalNotification } from '../../../common/components/global-notification/global-notification';
import { PopupFactory } from '../../../common/components/popup/popup';
import './add-to-favourites.less';
import Icon from '../../../images-svg-sprite/star_white.svg';
import IconEmpty from '../../../images-svg-sprite/star_white_empty.svg';
import { getProductData } from '../utils/data';
import { makeUrl } from '../../../utils/makeUrl';
import { resolveUrl } from '../../../utils/resolveUrl';

export class Favorites {
    constructor(elementID) {
        try {
            this.button = document.getElementById(elementID);
            this.buttonWrapper = this.button.parentElement;
            this.button.addEventListener('click', this.handleClick);
            const {
                logged_user: loggedUser,
                gift_id: giftId,
                giftlist_id: giftListId,
                add_wish_notification: addWishNotification,
            } = this.buttonWrapper.dataset;
            const { add_text, remove_text, add_title, remove_title } = getProductData();
            this.dict = {
                add_text,
                remove_text,
                add_title,
                remove_title,
            };
            this.isLoggedIn = loggedUser === 'true';
            this.giftId = giftId;
            this.giftlistId = giftListId;
            this.isAlreadyAdded = this.giftId !== '';
            this.isMessageShouldBeShown = addWishNotification === 'true';
            this.showMessageAfterLogin();
        } catch (error) {
            return false;
        }
    }

    static init(elementID) {
        return new Favorites(elementID);
    }

    handleClick = async () => {
        if (!this.isLoggedIn) {
            this.showLoginPopup();
            return;
        }
        try {
            if (this.isAlreadyAdded) {
                await this.remove();
            } else {
                await this.add();
            }
            this.isAlreadyAdded = !this.isAlreadyAdded;
        } catch (e) {
            const infoNotification = new GlobalNotification('error');
            Icon.width = 15;
            infoNotification.show(
                getProductData().msgServerError,
                document.querySelector('.main-wrapper')
            );
        }
    };

    getAccountLinkURL() {
        return resolveUrl('myaccount/myAccountMyList.jsp');
    }

    injectLink(rawUrl) {
        return rawUrl
            .replace(/\{favorites-link\}/, this.getAccountLinkURL())
            .replace('>', 'target="_blank" rel="noreferrer noopener nofollow" >');
    }

    async add() {
        try {
            const { skuId, productId } = getProductData();
            const { data } = await axios.post(
                makeUrl(
                    `/rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToFavorites`
                ),
                {
                    giftlistId: this.giftlistId,
                    productId,
                    quantity: 1,
                    catalogRefIds: [skuId],
                }
            );
            if (data.success === 'false') {
                throw new Error('Some error');
            }
            const [{ repositoryId }] = data.addedItems;
            this.giftId = repositoryId;
            this.showMessage();
            this.buttonWrapper.classList.add('add_to_favourites_state_added');
            this.button.querySelector('span').innerHTML = this.dict.remove_title;
        } catch (error) {
            const isUnauthorized = error.response && error.response.status === 403;
            if (isUnauthorized) {
                this.showLoginPopup();
            }
            throw error;
        }
    }

    async remove() {
        try {
            const { data } = await axios.post(
                makeUrl(
                    `/rest/model/atg/commerce/order/purchase/CartModifierActor/removeItemFromFavorites`
                ),
                {
                    giftlistId: this.giftlistId,
                    giftId: this.giftId,
                }
            );
            if (data.success === 'false') {
                throw new Error('Some Error');
            }
            const infoNotification = new GlobalNotification('info');
            IconEmpty.width = 15;
            infoNotification.show(
                this.injectLink(this.dict.remove_text),
                document.querySelector('.main-wrapper'),
                IconEmpty
            );
            this.buttonWrapper.classList.remove('add_to_favourites_state_added');
            this.button.querySelector('span').innerHTML = this.dict.add_title;
        } catch (error) {
            throw error;
        }
    }

    showLoginPopup() {
        const popup = PopupFactory({
            targetElement: '.js-add-to-fav-login',
            closeElement: '.js-cys-close, .js-cys-shadow',
        });
        popup.show();
    }

    showMessageAfterLogin() {
        if (this.isMessageShouldBeShown) {
            this.showMessage();
        }
    }

    showMessage() {
        const infoNotification = new GlobalNotification('info');
        Icon.width = 15;
        infoNotification.show(
            this.injectLink(this.dict.add_text),
            document.querySelector('.main-wrapper'),
            Icon
        );
    }
}
